<template>
    <div id="nav-container" v-if="$route.path !== '/'">
      <div id="layover-blur"
           :class="{ 'dark' : navFold === false }">
        <div id="layover"
             :class="{ 'dark' : navFold === false }"
             @click="() => { if (window.innerWidth < 600) navFold = true }">
        </div>
      </div>
        <div
            id="nav-button"
            @mouseenter="() => { if (window.innerWidth > 600) navFold = false }"
            @mouseleave="() => { if (window.innerWidth > 600) foldNav() }"
            :class="{ 'unfold' : navFold === false }">
            <img id="glare" src="../assets/interface/nav-crop.png"/>
            <div id="links">
                <router-link
                    :to="'/nour'"
                    :class="{ 'hide': this.navFold }"
                    @click="swapSeries(1);">Nour
                </router-link>
<!--              <router-link-->
<!--                  :to="'/fertile'"-->
<!--                  :class="{ 'hide': this.navFold }"-->
<!--                  @click="swapSeries(7);">Fertile-->
<!--              </router-link>-->
                <router-link
                    :to="'/peel'"
                    :class="{ 'hide': this.navFold}"
                    @click="swapSeries(2)">PEEL
                </router-link>
                <router-link
                    :to="'/collaborations'"
                    :class="{ 'hide': this.navFold}"
                    @click="swapSeries(3)">collaborations
                </router-link>
                <router-link
                    :to="'/installations'"
                    :class="{ 'hide': this.navFold}"
                    @click="swapSeries(4)">installations
                </router-link>
                <router-link
                    :to="'/store'"
                    :class="{ 'hide': this.navFold, 'sub-route-active' : this.$route.path.substring(0, 7) === '/store/'}"
                    @click="swapSeries(5)">store
                </router-link>
                <router-link
                    :to="'/about'"
                    :class="{ 'hide': this.navFold}"
                    @click="swapSeries(6)">about
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navFold: true,
            active: this.$store.state.$active
        };
    },
    methods: {
        swapSeries(val) {
            if (window.innerWidth > 800) {
                this.active = val;
                this.$store.commit('swapSeries', val);
                this.navFold = true;
            } else {
                let layOver = document.getElementById("layover");

                if (this.navFold === false) {
                    this.active = val;
                    this.$store.commit('swapSeries', val);
                    this.navFold = true;
                    layOver.style.pointerEvents = 'none';
                } else {
                    this.navFold = false;
                    layOver.style.pointerEvents = 'auto';
                }
            }
        },
        foldNav() {
            this.navFold = true;
        }
    },
    computed: {
        currentSeries() {
            return this.$store.state.$active;
        }
    }
};
</script>

<style>
#nav-button {
    position: absolute;
    width: 400px;
    top: 15px;
    left: 15px;
    height: 400px;
    pointer-events: auto;
    cursor: pointer;
    transform-origin: 0% 0%;
    transition: transform 0.75s;
    transform: scale(65%);
    z-index: 800;
    display: flex;
    justify-content: center;
    align-items: center;
}

#nav-button:hover {
    transform: scale(100%);
}

#links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    text-align: center;
}

#nav-button a {
    font-family: 'secondary' !important;
    font-weight: bold;
    padding-bottom: 5px;
    color: var(--menu-text-color) !important;
    line-height: 1.1;
    pointer-events: auto;
    user-select: none;
    text-align: center;
    text-shadow: #969696 0px 0 5rem;
    font-size: 1.8rem;
//font-weight: 900; //letter-spacing: .05rem; opacity: 1 !important;
}

#nav-button:hover a {
//filter: blur(0.05rem); font-size: 1.2rem;
}

#nav-button:hover a:hover {
    filter: blur(0px);
    color: var(--menu-hover-text-color) !important;
}

#glare {
    animation: opacityanim 3s infinite alternate-reverse;
}

#layover {
  backdrop-filter: blur(10px);
  background-image: linear-gradient(to right, rgb(238, 160, 14) 1%, rgb(208, 169, 39), rgb(255, 183, 0));
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 500;
    opacity: 0;
    transition: opacity 1s;
    pointer-events: none;
}

#layover-blur {
  backdrop-filter: blur(0px);
  transition: backdrop-filter 1s;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  pointer-events: none;
}

#layover-blur.dark{
  backdrop-filter: blur(5px);
}

#nav-button #glare {
    filter: blur(12px);
    transition: filter 1s;
}

#nav-button:hover #glare {
    filter: blur(15px);
}

#layover.dark {
    opacity: 0.6;
}

@keyframes bluranim {
    from {
        filter: blur(3px)
    }
    to {
        filter: blur(1px)
    }
}

#nav-button #glare {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

#nav-container a.router-link-active, #nav-container a.sub-route-active {
    color: var(--menu-active-color) !important;
}

a.hide:not(.router-link-active):not(.sub-route-active) {
    display: none;
}

@media only screen and (max-width: 800px) {
    #nav-button {
        transform: scale(40%);
        width: 90vw;
        height: 90vw;
        pointer-events: none;
    }

    #nav-button:hover {
        transform: scale(40%);
    }

    #nav-button.unfold {
        pointer-events: none;
        transform: scale(100%);
    }

    #nav-button:hover a {
        font-size: 1.8rem;
    }

    #nav-button.unfold a {
        font-size: 1.35rem;
    }

    #nav-button:hover a:hover {
        color: var(--menu-active-color) !important;
    }

}
</style>